import { defineMessages } from 'react-intl';
import { InstallMeterStep } from './enums/installMeterStep';

export const InstallMeterStepTranslated = defineMessages<InstallMeterStep>({
  [InstallMeterStep.InstallationTechnology]: {
    id: 'app.common.installMeterStep.InstallationTechnology',
    defaultMessage: 'Technologie IoT senzoru',
  },
  [InstallMeterStep.SensorScan]: {
    id: 'app.common.installMeterStep.sensorScan',
    defaultMessage: 'Přiřazení IoT senzoru',
  },
  [InstallMeterStep.SensorConnection]: {
    id: 'app.common.installMeterStep.sensorConnection',
    defaultMessage: 'Ověření připojení senzoru',
  },
  [InstallMeterStep.Hardwares]: {
    id: 'app.common.installMeterStep.hardwares',
    defaultMessage: 'Přiřazení sériových čísel',
  },
  [InstallMeterStep.InstallationDetail]: {
    id: 'app.common.installMeterStep.installationDetail',
    defaultMessage: 'Doplnění údajů',
  },
  [InstallMeterStep.Photo]: { id: 'app.common.installMeterStep.photo', defaultMessage: 'Fotodokumentace' },
  [InstallMeterStep.Review]: { id: 'app.common.installMeterStep.review', defaultMessage: 'Rekapitulace' },
});

export const InstallationTechnologyButtonConfig = defineMessages({
  dataSource: {
    id: 'app.common.dataSource',
    defaultMessage: 'Zdroj dat',
  },
  other: {
    id: 'app.common.other',
    defaultMessage: 'Jiný',
  },
});

export const InstallationPhotoMessages = defineMessages({
  packageLabelHelp: {
    id: 'app.installation.photo.packageLabel.help',
    defaultMessage: 'Vyfoť krabičku, ve které senzor přišel včetně etikety.',
  },
  packageLabelLabel: {
    id: 'app.installation.photo.packageLabel.label',
    defaultMessage: 'Fotka obalu včetně etikety',
  },
  openSensorHelp: {
    id: 'app.installation.photo.openSensor.help',
    defaultMessage: 'Vyfoť zapojení kanálu/inputu otevřeného senzoru.',
  },
  openSensorLabel: {
    id: 'app.installation.photo.openSensor.label',
    defaultMessage: 'Otevřený senzor zapojení',
  },
  closedSensorHelp: {
    id: 'app.installation.photo.closedSensor.help',
    defaultMessage: 'Vyfoť cokoliv, čím by se senzor dal identifikovat.',
  },
  closedSensorLabel: {
    id: 'app.installation.photo.closedSensor.label',
    defaultMessage: 'Senzor s viditelným DevEUI/QR kódem',
  },
  impulseConstantHelp: {
    id: 'app.installation.photo.impulseConstant.help',
    defaultMessage: 'Vyfoť impulzní konstantu',
  },
  impulseConstantLabel: {
    id: 'app.installation.photo.impulseConstant.label',
    defaultMessage: 'Impulzní konstanta',
  },
  connectionDetailHelp: {
    id: 'app.installation.photo.connectionDetail.help',
    defaultMessage: 'Vyfoť detail připojeného modulu k měřidlu.',
  },
  connectionDetailLabel: {
    id: 'app.installation.photo.connectionDetail.label',
    defaultMessage: 'Detail zapojení všech součástí odečtu (optooddělovač, splitter, ...)',
  },
  placementOverviewHelp: {
    id: 'app.installation.photo.placementOverview.help',
    defaultMessage: 'Vyfoť provedenou instalaci v celku. Podobně jako kontextová fotka při inventarizaci',
  },
  placementOverviewLabel: {
    id: 'app.installation.photo.placementOverview.label',
    defaultMessage: 'Fotodokumentace celek',
  },
});
